import { render, staticRenderFns } from "./Catalogo.vue?vue&type=template&id=29543394"
import script from "./Catalogo.vue?vue&type=script&lang=js"
export * from "./Catalogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports